export default
{
  'de-AT': [
    {
      date: "2019-05-08",
      newspaper: "Katholische Kirche Kärnten",
      link: "https://www.kath-kirche-kaernten.at/pfarren/detail/C2963/familienmusical-ruth",
      text: "mehr lesen"
    },
    {
      date: "2018-01-30",
      newspaper: "BTV",
      link: "http://www.btv.cc/hausruckviertel/sendung/2018_05/Familienmusical_Ruth_in_Eferding/7681",
      text: "ansehen"
    },
    {
      date: "2018-01-29",
      newspaper: "Tips",
      link: "https://www.tips.at/news/eferding/land-leute/415522-familienmusical-ruth-erobert-eferding-90-junge-musicalbegeisterte-spielten-fuer-900-zuschauer",
      text: "mehr lesen"
    },
    {
      date: "2017-10-28",
      newspaper: "meinbezirk.at",
      link: "https://www.meinbezirk.at/st-poelten/leute/das-familienmusical-ruth-von-kisi-d2299367.html",
      text: "mehr lesen"
    },
    {
      date: "2017-10-26",
      newspaper: "Mittelbayrische",
      link: "http://www.mittelbayerische.de/region/neumarkt-nachrichten/neumarkter-treten-in-ingolstadt-auf-21102-art1577151.html",
      text: "mehr lesen"
    },
    {
      date: "2017-10-19",
      newspaper: "Diözese St. Pölten",
      link: "http://presse.dsp.at/einrichtungen/kommunikation/artikel/2017/bischof-kueng-laedt-alle-erstkommunionkinder-zu-den-kisi",
      text: "mehr lesen"
    }
  ],
  'nl-NL': [
    {
      date: "2021-09-05",
      newspaper: "Katholiekleven.nl",
      link: "https://www.katholiekleven.nl/videos/actuele-videos/behind-the-scenes---ruth-de-musical",
      text: "lees verder"
    },
    {
      date: "2021-09-03",
      newspaper: "Nederlands Dagblad",
      link: "https://www.nd.nl/cultuur/cultuur/1058787/ruth-musical-is-vol-emoties",
      text: "lees verder"
    },
    {
      date: "2021-08-21",
      newspaper: "Katholiek Nieuwsblad",
      link: "https://www.kn.nl/verdieping/reportage/intense-repetities-maken-team-van-ruth-alleen-maar-hechter",
      text: "lees verder"
    }
  ],
  'en-GB':
    []
}



// WEBPACK FOOTER //
// ./src/components/Content/PressStatements.js